<template>
	<el-dialog
		title="机构列表"
		:append-to-body="true"
		:modal-append-to-body="true"
		:close-on-click-modal="falseValue"
		:visible.sync="showDialog"
		:modal="falseValue"
		custom-class="dialog-style list-dialog dialog-checkbox pd_0"
		width="1200px"
		@close="dialogClose"
		v-el-drag-dialog
		v-el-dialog-center
	>
		<div class="cont" style="height:450px">
			<vxe-grid
				class="is-pointer"
				ref="table-m1"
				v-bind="vxeOption"
				@resizable-change="$vxeTableUtil.onColumnWitchChange"
				@custom="$vxeTableUtil.customHandle"
				@checkbox-change="addDataTable"
				@checkbox-all="checkAll"
				@cell-dblclick="checkWithSubmit"
			>
				<template #form>
					<div class="clearfix screen-btns">
						<div class="fr">
							<vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text" status="primary" plain>重置</vxe-button>
							<vxe-button status="warning" icon="el-icon-search" class="button-sty" @click="searchEvent">搜索</vxe-button>
						</div>
					</div>
					<vxe-form class="screen-box" title-width="92px" title-align="right" :data="formData" @submit="searchEvent" @reset="resetEvent">
						<vxe-form-item title="机构名称:" field="name">
							<template v-slot>
								<el-input v-model="formData.name" size="small" clearable />
							</template>
						</vxe-form-item>
					</vxe-form>
				</template>
			</vxe-grid>
		</div>
		<label id="labBtn" class="transverse">
			<div class="icon">
				<i class="el-icon-more"></i>
				<i class="el-icon-more"></i>
			</div>
		</label>
		<div class="multipleChoice">
			<el-tooltip :enterable="false" effect="dark" content="全部删除" placement="top"><a class="allDel icon-quanbushanchu" @click="clearChecked()"></a></el-tooltip>
			<div class="list">
				<div class="item" v-for="(checkRow, index) in checkRows">
					<p>{{ checkRow.name }}</p>
					<a class="el-icon-close" @click="clearTable1Select(index)"></a>
				</div>
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>
			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="dialogPrimary" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { selectDialogMixins } from '@/mixins/selectDialog/index.js';
export default {
	name: 'saleOrgDialog',
	props: ['visiable', 'multi', 'rows', 'param'],
	mixins: [selectDialogMixins],
	created() {
		this.initSetting();
		if (this.param) {
			if (this.param.companyCode !== null) {
				this.formData.companyCode = this.param.companyCode;
			}
		}
	},
	mounted() {
		this.initTableM1();
	},
	data() {
		var that = this;
		return {
			showDialog: true,
			falseValue: false,
			selectMulti: true,
			formData: {},
			vxeOption: {}
		};
	},
	methods: {
		initTableM1() {
			let that = this;
			let url =
				this.param && (this.param.queryAll === 'true' || this.param.queryAll === true) ? USER_PREFIX + '/sale_org/getAllList' : USER_PREFIX + '/sale_org/getCurrentList';
			let tableOption = {
				vue: that,
				tableRef: 'table-m1',
				tableName: 'basic_sale_org_dialog-m1',
				path: url,
				treeNodeUrl: USER_PREFIX + '/sale_org/getChildren',
				treeNodeParam(row) {
					return {
						parent: row.id,
						enabled: true
					};
				},
				param: () => {
					this.formData.enabled = true;
					return this.formData;
				},
				columns: [
					{ type: 'checkbox', width: 50, resizable: false, fixed: 'left' },
					{ title: '机构名称', field: 'name', width: 250, fixed: 'left', treeNode: true },
					{ title: '机构编码', field: 'sn', width: 200 },
					{ title: '所属组织', field: 'companyName', width: 150 },
					{ title: '上级机构', field: 'tree_path_name', width: 200 },
					{
						width: 47,
						fixed: 'right',
						title: '',
						sortable: false
					}
				],
				config: {
					checkboxConfig: {
						checkStrictly: true,
						showHeader: this.selectMulti,
						trigger: 'row'
					}
				}
			};
			this.$vxeTableUtil.initVxeTable(tableOption).then(opts => {
				that.vxeOption = opts;
			});
		}
	}
};
</script>
